import { parseArrayResponse, parseStringResponse } from "../utils";

import IQuote from "apiConsumers/kenticoApiConsumer/models/quotes/IQuote";

export default function convertQuoteResponse(response: any): IQuote[] | undefined {
    const { items } = response;

    const parsedItems = parseArrayResponse(items);
    if (typeof parsedItems === "undefined") return undefined;

    let _quotes: IQuote[] = [];
    parsedItems.forEach((quote) => {
        const _quote = convertQuote(quote);
        if (typeof _quote === "undefined") return;

        _quotes.push(_quote);
    });

    return _quotes;
}

function convertQuote(quoteResponse: any): IQuote | undefined {
    const { content, source } = quoteResponse;

    const _content = parseStringResponse(content);
    if (typeof _content === "undefined") return undefined;

    const _source = parseStringResponse(source);
    if (typeof _source === "undefined") return undefined;

    return { content: _content, source: _source };
}
